import styled from 'styled-components'

const Placeholder = (styled.div || styled.View)`
  color: #757575; /* chrome default */
`

export default Placeholder
